/*
* Product Image ScrollTo Interaction
*
**/

// Google Tag Manager DataLayer Helper
require('custom/gtm-datalayer');

custom.gtmHandler = (() => {

	const gtmElemClassName = 'js-gtm';
	const gtmWrapClassName = 'js-gtm-wrapper';
	const gtmInitClassName = 'js-gtm--initialized';

	function initClassHandler(elem=null) {
		if(!$(elem).hasClass(gtmInitClassName)) $(elem).addClass(gtmInitClassName);
	}

	function exceptionAdaptor(data={}, elem=null, evt={}) {
    const $elem = $(elem);

		// Quick View click event propagation
		if($(evt.target).hasClass("js-quick-view-button") && data.eventCategory !== "Quick Add" && $(elem).text() !== "Shop This Scene") return false;

    // Download Hangtags
    if($(evt.target).hasClass('js-download-button') && data.eventLabel == 'Download Hangtags') {
      data.eventAction = $('#downloadsSelect option:selected').text();
    }

    // Download Photos
    if($(evt.target).hasClass('js-download-button') && data.eventLabel == 'Download Images') {
      const category = $('#downloadsType option:selected').text();
      const collection = $('#downloadsSelect option:selected').text();

      data.eventAction = category + ' - ' + collection;
    }

		// Become A Dealer Bumper
		if($elem.attr('href') == '/account/register' && data.eventAction == 'Bumper') {
			data.eventLabel = 'Become A Dealer';
		}
		// Homepage contents
		if(data.eventCategory == 'Home Page' && data.eventAction == 'Content') {
			data.eventLabel = $elem.attr('href').replace('/collections/', '');
		}
		// Search Filter
		if(data.eventCategory == 'Side Bar' && data.eventAction == 'Filter') {
      if ($elem.find('input').prop('checked') == false) return false;
      if ($elem.find('input').val() == 'in-stock') {
        data.eventLabel = "In Stock";
      } else {
        const label = $elem.closest('.ais-body').siblings('.ais-header').text().replace('?', '').trim();
        data.eventLabel = label + ' - ' + (label === 'Price' ? $elem.find('label').clone().children().remove().end().text().trim() : $elem.find('input').val());
      }
		}
		// How to Buy - Google Shop Online Form
		if(data.eventCategory == 'How To Buy' && data.eventAction == 'Shop Online Search') {
			data.eventLabel = $elem.closest('form').find('input[type="text"]').val();
		}
		// Editorial Detail - Shop This Scene
		if (window.location.href.includes('/blogs/editorial/') && $elem.text() === 'Shop This Scene') {
			data.eventAction = "Info";
		}
    // About, Collaboration - Editorial Links
		if (
			(window.location.href.includes('/pages/about') || data.eventAction === 'Learn More') && $elem.attr('href') && $elem.attr('href').includes('/blogs/editorial/')
		) {
			const arr = $elem.attr('href').split('/');
			data.eventLabel = custom.utils.titleCase(arr[arr.length - 1].replace(/-/g, ' ')) + '.';
		}

		// Showrooms Expanding Details
		if (data.eventCategory == 'Showrooms' && $elem.hasClass('js-accordion-trigger')) {
			if ($elem.data('expand') == false) {
				$elem.data('expand', true);
				return false;
			} else if ($elem.data('expand') == true) {
				$elem.data('expand', false);
			}
		}

		// FAQ Accordion
		if (data.eventCategory == 'FAQ' && $elem.hasClass('js-accordion-trigger')) {
			if ($elem.parent('.accordion__item').hasClass('js-accordion-open')) return false;
		}

		// FAQ & PDP accordion
		if($elem.hasClass('js-accordion-trigger')) {
			const appendText = $elem.data('label-append');

			if (appendText) {
				data.eventLabel = $elem.text() + ' - ' + appendText;

				if (appendText === 'Expand') {
					$elem.data('label-append', 'Minimize');
				} else {
					$elem.data('label-append', 'Expand');
				}

			}
		}

		if (data.eventAction == 'Collection') {
			if ($(event.srcElement).closest('.collection-card__thumbnails').length > 0) {
				return false;
			}
		}

		return data;
	}

	function initCertainElements() {

		function addInitClass(links=[]) {
			$.each($(links), function (index, link) {
				const $link = $(link);
				$link.addClass(gtmElemClassName);
			});
		}

		// Editorial Detail copy links
		const $copyBlock = $('.js-editorial-copy');
		addInitClass($copyBlock.find('a:not(.' + gtmInitClassName + ')'));

		// GTM Wrapper
		const $wrapper = $('.js-gtm-wrapper');
    addInitClass($wrapper.find(`a:not(.${gtmInitClassName}), .js-quick-view-button`));
    addInitClass($wrapper.find(`button:not(.${gtmInitClassName}), .js-quick-view-button`));
	}

	function pushDataLayer(e=null) {
		// e.preventDefault();
		// make sure all required tags are there
	  const elem = $(this);

		// default GAEvent if undefined as data attribute
	  const event = elem.data('event') ? elem.data('event') : 'GAEvent';

		// If undefined, get the closest element up that has a category
	  const category = elem.data('category') ? elem.data('category') : elem.closest('[data-category]').data('category');

		// If undefined, get the closest element up that has a action
	  const action = elem.data('action') ? elem.data('action') : elem.closest('[data-action]').data('action');

		// if you do not define the label, it will try to find text
		// inside the documentElement as a backup
	  const label = elem.data('label') ? elem.data('label') : $.trim(elem.text());

		// Prepare the payload object
		let data = {
			event: event,
			eventCategory: category,
			eventAction: action,
			eventLabel: label,
		};

		// Adjust few attribute if needed
		data = exceptionAdaptor(data, elem, e);
		// TODO remove
		//console.log(data);

	  if(data) {
	    custom.gtmDatalayer.gtmPush(data);
	  }
	}

	function init() {
		initCertainElements();
		$.each($(`.${gtmElemClassName}`), (index, elem) => {
			if(!$(elem).hasClass(gtmInitClassName)) $(elem).on('click', pushDataLayer);
			initClassHandler($(elem));
		});
	}

	return {
		init,
		pushDataLayer
	}

})();



// WEBPACK FOOTER //
// ./src/scripts/src/custom/gtm-handler.js